<template>
  <b-form @submit.prevent="submit">
    <b-form-group class="mt-4"
                  :state="$v.passwordData.oldPassword.$error ? false : null"
                  :invalid-feedback="$t('error.changePasswordForm.oldPassword')">
      <label>
        {{ $t('message.changePasswordForm.label.oldPassword') }}
        <span class="text-danger">*</span>
      </label>
      <b-form-input class="rounded-0"
                    type="password"
                    v-model="passwordData.oldPassword"
                    :state="$v.passwordData.oldPassword.$error ? false : null"
                    @change="$v.passwordData.oldPassword.$touch()">
      </b-form-input>
    </b-form-group>
    <b-form-group class="mt-4"
                  :state="$v.passwordData.newPassword.$error ? false : null"
                  :invalid-feedback="$t('error.changePasswordForm.newPassword')">
      <label>
        {{ $t('message.changePasswordForm.label.newPassword') }}
        <span class="text-danger">*</span>
      </label>
      <b-form-input class="rounded-0"
                    type="password"
                    v-model="passwordData.newPassword"
                    :state="$v.passwordData.newPassword.$error ? false : null"
                    @change="$v.passwordData.newPassword.$touch()">
      </b-form-input>
    </b-form-group>
    <b-form-group class="mt-4"
                  :state="$v.passwordData.newPasswordConfirm.$error ? false : null"
                  :invalid-feedback="$t('error.changePasswordForm.newPasswordConfirm')">
      <label>
        {{ $t('message.changePasswordForm.label.newPasswordConfirm') }}
        <span class="text-danger">*</span>
      </label>
      <b-form-input class="rounded-0"
                    type="password"
                    v-model="passwordData.newPasswordConfirm"
                    :state="$v.passwordData.newPasswordConfirm.$error ? false : null"
                    @change="$v.passwordData.newPasswordConfirm.$touch()">
      </b-form-input>
    </b-form-group>
    <b-form-row class="mt-4">
      <b-col class="text-right">
        <b-btn variant="primary" type="submit">
          <span class="ti-save mr-2"></span>
          {{ $t('message.changePasswordForm.btn.save') }}</b-btn>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
  import { required, sameAs } from 'vuelidate/lib/validators'
  import utils from '@/utils'
  export default {
    methods: {
      submit () {
        const vm = this
        vm.$v.$touch()
        if (!vm.$v.$invalid) {
          vm.onSubmit(vm.passwordData)
            .then(() => vm.$v.$reset())
        }
      }
    },
    props: {
      onSubmit: {
        type: Function,
        required: true
      },
      passwordData: {
        type: Object,
        required: true
      }
    },
    validations: {
      passwordData: {
        oldPassword: {
          required
        },
        newPassword: {
          required,
          isValidPassword: utils.validators.isValidPassword
        },
        newPasswordConfirm: {
          required,
          sameAsNewPassword: sameAs('newPassword')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/ChangePasswordForm.vue